import AttachedDynamicConfiguration from './AttachedDynamicConfiguration';

export default AttachedDynamicConfiguration;
